import { EntityLinks, PrefixedID, Relationship } from '@griply/types';

const ID_SEPARATOR = ':';

// Structural, not isValidPrefixedId: a prefix this build doesn't know yet must survive the round trip.
const isWellFormedPrefixedId = (id: PrefixedID): boolean => {
  const separatorIndex = id.indexOf(ID_SEPARATOR);
  return separatorIndex > 0 && separatorIndex < id.length - 1;
};

const addLink = (
  links: Record<PrefixedID, PrefixedID[]>,
  key: PrefixedID,
  value: PrefixedID,
): void => {
  const references = (links[key] = links[key] ?? []);

  if (references.includes(value)) {
    return;
  }

  references.push(value);
};

export const buildEntityLinks = (
  relationships: Relationship[],
): EntityLinks => {
  const outgoing: Record<PrefixedID, PrefixedID[]> = {};
  const incoming: Record<PrefixedID, PrefixedID[]> = {};

  relationships.forEach(({ id, references }) => {
    if (!isWellFormedPrefixedId(id)) {
      return;
    }

    outgoing[id] = outgoing[id] ?? [];

    references.forEach((reference) => {
      if (!isWellFormedPrefixedId(reference)) {
        return;
      }

      addLink(outgoing, id, reference);
      addLink(incoming, reference, id);
    });
  });

  return { outgoing, incoming };
};
